module.exports = __webpack_public_path__ + "img/madelegabel.53e8907e.jpg";